import Extend from 'flarum/common/extenders';
import StoreItem from './models/StoreItem';
import PurchaseHistory from './models/PurchaseHistory';
export default [new Extend.Store().add('store-item', StoreItem).add('purchase-history', PurchaseHistory)];